import Base from './Base';

export default class ContactUnlinkedConflict extends Base {
    get phoneNumbers() {
        const phones = [];

        if (this.mobile_phone) {
            phones.push({
                key: 'mobile',
                label: 'Mobile Phone',
                value: this.mobile_phone,
            });
        }

        if (this.phone) {
            phones.push({
                key: 'phone',
                label: 'Phone',
                value: this.phone,
            });
        }

        return phones;
    }

    get phoneNumbersCount() {
        return this.phoneNumbers.length;
    }
}
